import PropTypes from 'prop-types';
import { formattedName } from 'lib/formatters';

const FormattedName = ({ name }) => {
  return <>{formattedName(name)}</>;
};

FormattedName.propTypes = {
  name: PropTypes.shape({
    title: PropTypes.string.isRequired,
    given: PropTypes.string.isRequired,
    family: PropTypes.string.isRequired,
  }).isRequired,
};

export default FormattedName;
